import { Box, Dialog, Portal, Table, VStack } from '@chakra-ui/react';
import { ReactComponent as DepositIcon } from 'assets/icons/deposit.svg';
import { useTranslation } from 'localization';

import {
  Button,
  DIALOG_ACTION_BUTTON_PROPS,
  ServiceDialogBody,
  ServiceDialogCloseTrigger,
  ServiceDialogFooter,
  ServiceDialogHeader,
  serviceDialogShellProps,
} from 'components';

type ApproveModalType = {
  onClose: () => void;
  isOpen: boolean;
  loading: boolean;
  data: {
    to: string;
    amount: number;
    pay_with: string;
  };
  onButton: () => void;
};

const ApproveModal: React.FC<ApproveModalType> = ({
  onClose,
  isOpen,
  loading,
  data,
  onButton,
}: ApproveModalType) => {
  const { t } = useTranslation('component.deposit.ld.approveModal');

  return (
    <Box display="flex" alignItems="center">
      <Dialog.Root
        size="xl"
        open={isOpen}
        placement="center"
        onOpenChange={(e: { open: boolean }) => {
          if (!e.open) {
            onClose();
          }
        }}
      >
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content {...serviceDialogShellProps({ maxW: 'xl' })}>
              <ServiceDialogHeader>{t('confirm')}</ServiceDialogHeader>
              <ServiceDialogCloseTrigger />
              <ServiceDialogBody py={6} px={4}>
                <VStack align="center" justify="flex-start" w="100%">
                  <VStack w="100%" align="center" justify="center" flex="auto">
                    <DepositIcon width={80} height={80} />
                  </VStack>
                  <Table.ScrollArea w="100%" overflowX="auto">
                    <Table.Root variant="line">
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell textAlign="left">{t('to')}</Table.Cell>
                          <Table.Cell textAlign="right">{data.to}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell textAlign="left">
                            {t('pay_with')}
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            {data.pay_with}
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell textAlign="left">
                            {t('amount')}
                          </Table.Cell>
                          <Table.Cell textAlign="right">
                            {data.amount}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table.Root>
                  </Table.ScrollArea>
                </VStack>
              </ServiceDialogBody>
              <ServiceDialogFooter>
                <Button
                  w="100%"
                  variant="filled"
                  title={t('confirm')}
                  onClick={() => {
                    onButton();
                    onClose();
                  }}
                  isLoading={loading}
                  {...DIALOG_ACTION_BUTTON_PROPS}
                />
              </ServiceDialogFooter>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </Box>
  );
};

export default ApproveModal;
